// tslint:disable:component-selector
import { Component, Input, OnInit } from '@angular/core';
//
// Components
//
import * as Library from '../../../../core/library/index';

@Component({
  selector: 'rti-cash-card',
  templateUrl: './rti-cash-card.html',
  styleUrls: ['./rti-cash-card.scss']
})
export class RtiCashCard implements OnInit {
  @Input() data: any;

  public ngOnInit() {
  }

  constructor() {
  }
}
